import React from 'react'
import { ArrowDown2 } from 'iconsax-react'
import { useAppDispatch, useAppSelector } from '@SonarCX/hooks/redux'
import { useTheme } from '@mui/material'

import ButtonMenu from '../ButtonMenu'

import { fetchTypes } from '@SonarCX/slices/userType'
import useStyles from './styles'

const TypesMenu = ({
  selected,
  onSelect,
  className,
  disabled,
  hideInternal,
  hideExternal,
  addSystemDefault = false,
  ...props
}) => {
  const dispatch = useAppDispatch()
  const theme = useTheme()

  const userTypes = useAppSelector(storeState => storeState.userType)

  React.useEffect(() => {
    if (!userTypes.loaded && !userTypes.loading) {
      dispatch(fetchTypes())
    }
  }, [userTypes, dispatch])

  const options = React.useMemo(() => {
    let allTypes = [...userTypes.types]

    if (hideInternal) {
      allTypes = allTypes.filter(t => t.external)
    }

    if (hideExternal) {
      allTypes = allTypes.filter(t => !t.external)
    }
    if (addSystemDefault) {
      allTypes.unshift({ id: 'system_default', value: null })
    }

    return allTypes.map(type => type.id)
  }, [userTypes.types, hideInternal, hideExternal, addSystemDefault])

  const classes = useStyles({ disabled })

  const getTypeName = React.useCallback(
    id => {
      const type = userTypes.types.find(type => type.id === id)
      if (type) {
        return type.name.toUpperCase()
      } else if (id === 'system_default') {
        return 'SYSTEM DEFAULT'
      } else {
        return 'NO TYPE'
      }
    },
    [userTypes.types]
  )
  const selectedType = React.useMemo(
    () => getTypeName(selected),
    [getTypeName, selected]
  )

  if (disabled) {
    return <>{selectedType}</>
  }

  return (
    <ButtonMenu
      options={options}
      onSelect={onSelect}
      selected={selected ?? 'null'}
      renderFunc={getTypeName}
      className={className ?? classes.root}
      disabled={disabled}
      {...props}
    >
      {selectedType}

      <ArrowDown2 size={theme.size.base} className={classes.icon} />
    </ButtonMenu>
  )
}

export default TypesMenu
